import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, StarIcon, ShieldCheckIcon, TruckIcon, StarHalf } from 'lucide-react';
export function ProductOffer() {
  return <div className="my-12 p-6 md:p-8 bg-slate-50 border border-slate-200 rounded-xl shadow-sm" id="offer" data-id="element-167">
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-168">
        {/* Product Image Placeholder */}
        <div className="w-full md:w-1/2 aspect-square bg-white border border-slate-100 rounded-lg flex items-center justify-center relative overflow-hidden group" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/vbhongC9Esk31hzprxQwWw/pomelli-image.png" alt="DeepClean Flow cordless water flosser product shot" className="w-full h-full object-contain p-8" data-id="element-170" />
          {/* Badge */}
          <div className="absolute top-4 left-4 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-171">
            Best Seller
          </div>
        </div>

        {/* Offer Details */}
        <div className="w-full md:w-1/2 space-y-6" data-id="element-172">
          <div data-id="element-173">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-174">
              The DeepClean Flow
            </h3>
            <div className="flex items-center gap-2 mb-4" data-id="element-175">
              <div className="flex text-yellow-400" data-id="element-176">
                {[...Array(4)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-177" />)}
                <StarHalf className="w-4 h-4 fill-current" data-id="element-178" />
              </div>
              <span className="text-sm text-slate-600" data-id="element-179">
                4.6/5 Rating (14,000+ Users)
              </span>
            </div>
            <p className="text-slate-600 mb-4" data-id="element-180">
              The cordless, rechargeable water flosser designed to make the
              habit stick. Gentle, effective, and built for real life.
            </p>
          </div>

          <ul className="space-y-3" data-id="element-181">
            {['Removes 99.9% of plaque from treated areas', '50% more effective than string floss', 'Cordless & USB Rechargeable', 'Waterproof & Shower Safe', '30-Day Money-Back Guarantee'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-700" data-id="element-182">
                <CheckIcon className="w-5 h-5 text-green-500 shrink-0" data-id="element-183" />
                {item}
              </li>)}
          </ul>

          <div className="pt-4 space-y-3" data-id="element-184">
            <a href="https://flossfocus.com/products/the-flossfocus-precision" target="_blank" rel="noopener noreferrer" className="block" data-id="element-185">
              <Button size="lg" fullWidth className="text-lg shadow-lg shadow-orange-500/20" data-id="element-186">
                Try the DeepClean Flow — Risk Free →
              </Button>
            </a>

            <div className="flex items-center justify-center gap-4 text-xs text-slate-500" data-id="element-187">
              <span className="flex items-center gap-1" data-id="element-188">
                <TruckIcon className="w-3 h-3" data-id="element-189" /> Free Shipping
              </span>
              <span className="flex items-center gap-1" data-id="element-190">
                <ShieldCheckIcon className="w-3 h-3" data-id="element-191" /> 30-Day Guarantee
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}